export default __webpack_public_path__ + "static/media/industry3.fd18cfa0.png";